import {
  BusinessLineDto,
  DocumentUsedDto,
  IndustryDto,
  ProjectSizeCategoryDto,
  UserDto
} from '../services/generated';
import {DocumentBase} from './DocumentBase';
import {ProcessMinimum} from './ProcessMinimum';

export class DocumentRecent extends DocumentBase implements DocumentUsedDto {
  public ownerProcessId: number;
  public projectSizeCategories: ProjectSizeCategoryDto[] | null;
  public industries: IndustryDto[] | null;
  public processes: Array<ProcessMinimum> | null;
  public auditable: boolean;

  public created: string | null;
  public createdBy: UserDto | null;
  public modified: string | null;
  public modifiedBy: UserDto | null;
  public isBroken: boolean = false;
  public businessLines: BusinessLineDto[] | null;
  public isFavorite: boolean;
  public nextConfirmationDate: string | null;

  constructor(document: DocumentUsedDto) {
    super(document);
    this.ownerProcessId = document.ownerProcessId;
    this.projectSizeCategories = document.projectSizeCategories;
    this.industries = document.industries;
    this.processes = document.processes?.map(process => new ProcessMinimum(process)) || null;
    this.auditable = document.auditable;
    this.nextConfirmationDate = document.nextConfirmationDate;

    this.created = document.created;
    this.createdBy = document.createdBy;
    this.modified = document.modified;
    this.modifiedBy = document.modifiedBy;
    this.businessLines = document.businessLines;
    this.isFavorite = document.isFavorite;
  }
}
